// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.DotsMenu_scroll__sclOr::-webkit-scrollbar {
  height: 8px;
}
.DotsMenu_scroll__sclOr::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.DotsMenu_scroll__sclOr::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.DotsMenu_DotsMenu__d4bkL {
  position: relative;
  width: auto;
  z-index: 1;
}
.DotsMenu_DotsMenu__d4bkL button {
  background: none;
  border: 0;
  outline: 0 none;
  cursor: pointer;
  color: var(--mainColor);
  vertical-align: middle;
  margin-top: 2px;
}
.DotsMenu_DotsMenu__d4bkL div[role="tooltip"] {
  transform: none !important;
  top: calc(100% + 20px) !important;
}
body[dir=ltr] .DotsMenu_DotsMenu__d4bkL div[role="tooltip"] {
  right: 0;
  left: auto !important;
}
body[dir=rtl] .DotsMenu_DotsMenu__d4bkL div[role="tooltip"] {
  left: 0;
  right: auto;
}
.DotsMenu_DotsMenu__d4bkL div[data-testid="popper-holder"] {
  top: 30px !important;
  transform: none !important;
}
body[dir=ltr] .DotsMenu_DotsMenu__d4bkL div[data-testid="popper-holder"] {
  right: 10px !important;
  left: auto !important;
}
body[dir=rtl] .DotsMenu_DotsMenu__d4bkL div[data-testid="popper-holder"] {
  left: 10px !important;
  right: auto !important;
}
.DotsMenu_DotsMenu__d4bkL svg {
  transition: 0.3s;
}

.DotsMenu_popperMenu__r65Ly {
  position: relative;
  min-width: 147px;
  background-color: var(--bgColor) !important;
}
body[dir=ltr] .DotsMenu_popperMenu__r65Ly {
  transform: translateX(11px);
}
body[dir=rtl] .DotsMenu_popperMenu__r65Ly {
  transform: translateX(-11px);
}
.DotsMenu_popperMenu__r65Ly::before {
  content: "";
  position: absolute;
  display: block;
  top: 0;
  transform: translateY(-14px);
  border: 7px solid transparent;
  border-bottom-color: var(--borderColor);
  z-index: 9;
}
body[dir=ltr] .DotsMenu_popperMenu__r65Ly::before {
  left: 87%;
}
body[dir=rtl] .DotsMenu_popperMenu__r65Ly::before {
  right: 87%;
}
.DotsMenu_popperMenu__r65Ly::after {
  content: "";
  position: absolute;
  display: block;
  border: 7px solid transparent;
  top: 0;
  transform: translateY(-13px);
  border-bottom-color: var(--bgColor);
  z-index: 9;
}
body[dir=ltr] .DotsMenu_popperMenu__r65Ly::after {
  left: 87%;
}
body[dir=rtl] .DotsMenu_popperMenu__r65Ly::after {
  right: 87%;
}
.DotsMenu_popperMenu__r65Ly ul {
  list-style: none;
}
.DotsMenu_popperMenu__r65Ly ul li {
  padding: 0.5rem;
}
.DotsMenu_popperMenu__r65Ly ul li span {
  cursor: pointer;
  margin-bottom: 0.5rem;
  display: block;
  font-size: 10px !important;
  font-weight: 400;
  white-space: nowrap;
}
body[dir=ltr] .DotsMenu_popperMenu__r65Ly ul li span {
  font-family: "LatoRegular", "CairoRegular", sans-serif;
}
body[dir=rtl] .DotsMenu_popperMenu__r65Ly ul li span {
  font-family: "CairoRegular", "LatoRegular", sans-serif;
}
.DotsMenu_popperMenu__r65Ly ul li span:hover {
  color: var(--secondaryColor) !important;
}
.DotsMenu_popperMenu__r65Ly ul li div {
  font-size: 7px;
  text-transform: capitalize;
}
.DotsMenu_popperMenu__r65Ly ul li:not(:last-of-type) {
  border-bottom: 1px solid var(--borderColor);
}
.DotsMenu_popperMenu__r65Ly ul .DotsMenu_optionDimmed__1zLOn {
  opacity: 0.5;
}
.DotsMenu_popperMenu__r65Ly ul .DotsMenu_optionDimmed__1zLOn span {
  cursor: default;
}
.DotsMenu_popperMenu__r65Ly ul .DotsMenu_optionDimmed__1zLOn span:hover {
  color: var(--mainColor) !important;
}

.DotsMenu_ExportPNG__WSd8Q {
  font-size: 12px !important;
  background: none;
  border: 0;
  outline: 0 none;
  cursor: pointer;
  text-transform: capitalize;
  flex-shrink: 0;
  white-space: nowrap;
  transition: 0.3s;
  margin: 0;
}
body[dir=ltr] .DotsMenu_ExportPNG__WSd8Q {
  font-family: "LatoRegular", "CairoRegular", sans-serif;
}
body[dir=rtl] .DotsMenu_ExportPNG__WSd8Q {
  font-family: "CairoRegular", "LatoRegular", sans-serif;
}
.DotsMenu_ExportPNG__WSd8Q:hover {
  color: var(--secondaryColor);
}

.MuiSvgIcon-root {
  font-size: 1rem;
  -webkit-margin-end: -10px;
          margin-inline-end: -10px;
}
div[class*=makeStyles-paper] {
  padding: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/DotsMenu/DotsMenu.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAsDF;AApDE;EACE,gBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AAsDJ;AAnDE;EACE,0BAAA;EASA,iCAAA;AA6CJ;AArDI;EACE,QAAA;EACA,qBAAA;AAuDN;AArDI;EACE,OAAA;EACA,WAAA;AAuDN;AAlDE;EACE,oBAAA;EACA,0BAAA;AAoDJ;AAlDI;EACE,sBAAA;EACA,qBAAA;AAoDN;AAjDI;EACE,qBAAA;EACA,sBAAA;AAmDN;AA/CE;EACE,gBAAA;AAiDJ;;AAzCA;EACE,kBAAA;EACA,gBAAA;EACA,2CAAA;AA4CF;AA3CE;EACE,2BAAA;AA6CJ;AA3CE;EACE,4BAAA;AA6CJ;AA3CE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EAOA,MAAA;EACA,4BAAA;EACA,6BAAA;EACA,uCAAA;EACA,UAAA;AAuCJ;AAjDI;EACE,SAAA;AAmDN;AAjDI;EACE,UAAA;AAmDN;AA1CE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EAOA,6BAAA;EACA,MAAA;EACA,4BAAA;EACA,mCAAA;EACA,UAAA;AAsCJ;AAhDI;EACE,SAAA;AAkDN;AAhDI;EACE,UAAA;AAkDN;AA1CE;EACE,gBAAA;AA4CJ;AA3CI;EACE,eAAA;AA6CN;AA5CM;EACE,eAAA;EACA,qBAAA;EACA,cAAA;EDEJ,0BAAA;ECAI,gBAAA;EACA,mBAAA;AA8CR;AA7CQ;EACE,sDDpDI;ACmGd;AA7CQ;EACE,sDDrDK;ACoGf;AA7CQ;EACE,uCAAA;AA+CV;AA5CM;EACE,cAAA;EACA,0BAAA;AA8CR;AA5CM;EACE,2CAAA;AA8CR;AA3CI;EACE,YAAA;AA6CN;AA5CM;EACE,eAAA;AA8CR;AA7CQ;EACE,kCAAA;AA+CV;;AAxCA;ED9BI,0BAAA;ECgCF,gBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AA2CF;AA1CE;EACE,sDD7FU;ACyId;AA1CE;EACE,sDD9FW;AC0If;AAzCE;EACE,4BAAA;AA2CJ;;AAvCE;EACE,eAAA;EACA,yBAAA;UAAA,wBAAA;AA0CJ;AAxCE;EACE,wBAAA;AA0CJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.DotsMenu {\n  position: relative;\n  width: auto;\n  z-index: 1;\n\n  button {\n    background: none;\n    border: 0;\n    outline: 0 none;\n    cursor: pointer;\n    color: var(--mainColor);\n    vertical-align: middle;\n    margin-top: 2px;\n  }\n\n  :global(div[role='tooltip']) {\n    transform: none !important;\n    #{$ltr} & {\n      right: 0;\n      left: auto !important;\n    }\n    #{$rtl} & {\n      left: 0;\n      right: auto;\n    }\n    top: calc(100% + 20px) !important;\n  }\n\n  :global(div[data-testid='popper-holder']) {\n    top: 30px !important;\n    transform: none !important;\n\n    #{$ltr} & {\n      right: 10px !important;\n      left: auto !important;\n    }\n\n    #{$rtl} & {\n      left: 10px !important;\n      right: auto !important;\n    }\n  }\n\n  svg {\n    transition: 0.3s;\n    // margin-inline-start: 10px;\n  }\n  //   div {\n  //   border: 1px solid var(--borderColor);\n  // }\n}\n\n.popperMenu {\n  position: relative;\n  min-width: 147px;\n  background-color: var(--bgColor) !important;\n  #{$ltr} & {\n    transform: translateX(11px);\n  }\n  #{$rtl} & {\n    transform: translateX(-11px);\n  }\n  &::before {\n    content: '';\n    position: absolute;\n    display: block;\n    #{$ltr} & {\n      left: 87%;\n    }\n    #{$rtl} & {\n      right: 87%;\n    }\n    top: 0;\n    transform: translateY(-14px);\n    border: 7px solid transparent;\n    border-bottom-color: var(--borderColor);\n    z-index: 9;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    display: block;\n    #{$ltr} & {\n      left: 87%;\n    }\n    #{$rtl} & {\n      right: 87%;\n    }\n    border: 7px solid transparent;\n    top: 0;\n    transform: translateY(-13px);\n    border-bottom-color: var(--bgColor);\n    z-index: 9;\n  }\n  ul {\n    list-style: none;\n    li {\n      padding: 0.5rem;\n      span {\n        cursor: pointer;\n        margin-bottom: 0.5rem;\n        display: block;\n        @include fontSize(10);\n        font-weight: 400;\n        white-space: nowrap;\n        #{$ltr} & {\n          font-family: $latoRegular;\n        }\n        #{$rtl} & {\n          font-family: $CairoRegular;\n        }\n        &:hover {\n          color: var(--secondaryColor) !important;\n        }\n      }\n      div {\n        font-size: 7px;\n        text-transform: capitalize;\n      }\n      &:not(:last-of-type) {\n        border-bottom: 1px solid var(--borderColor);\n      }\n    }\n    .optionDimmed {\n      opacity: 0.5;\n      span {\n        cursor: default;\n        &:hover {\n          color: var(--mainColor) !important;\n        }\n      }\n    }\n  }\n}\n\n.ExportPNG {\n  @include fontSize(12);\n  background: none;\n  border: 0;\n  outline: 0 none;\n  cursor: pointer;\n  text-transform: capitalize;\n  flex-shrink: 0;\n  white-space: nowrap;\n  transition: 0.3s;\n  margin: 0;\n  #{$ltr} & {\n    font-family: $latoRegular;\n  }\n  #{$rtl} & {\n    font-family: $CairoRegular;\n  }\n\n  &:hover {\n    color: var(--secondaryColor);\n  }\n}\n:global {\n  .MuiSvgIcon-root {\n    font-size: 1rem;\n    margin-inline-end: -10px;\n  }\n  div[class*='makeStyles-paper'] {\n    padding: 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `DotsMenu_scroll__sclOr`,
	"DotsMenu": `DotsMenu_DotsMenu__d4bkL`,
	"popperMenu": `DotsMenu_popperMenu__r65Ly`,
	"optionDimmed": `DotsMenu_optionDimmed__1zLOn`,
	"ExportPNG": `DotsMenu_ExportPNG__WSd8Q`
};
export default ___CSS_LOADER_EXPORT___;
